import { render, staticRenderFns } from "./BUTTON.vue?vue&type=template&id=68aafc00"
import script from "./BUTTON.vue?vue&type=script&lang=js"
export * from "./BUTTON.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports